"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createUniqueElementIds = require("../../utils/createUniqueElementIds/createUniqueElementIds");

var _DescriptionMessages = _interopRequireDefault(require("../FormControlFragments/DescriptionMessages"));

var _InputLabel = _interopRequireDefault(require("../FormControlFragments/InputLabel"));

var _excluded = ["ariaLabel", "ariaLabelledBy", "ariaValueTextLabel", "classes", "dataTestId", "description", "descriptionId", "errorMessages", "formControlId", "handleOnInput", "initialValue", "inputId", "isDescriptionHtml", "isDisabled", "isOptional", "isValid", "label", "labelId", "minValue", "maxValue", "stepBy"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RangeSlider = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      ariaValueTextLabel = _ref.ariaValueTextLabel,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleOnInput = _ref.handleOnInput,
      initialValue = _ref.initialValue,
      inputId = _ref.inputId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isOptional = _ref.isOptional,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      stepBy = _ref.stepBy,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleSetValue = function handleSetValue(event) {
    return setValue(event.target.value);
  };

  var _useState3 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState4 = _slicedToArray(_useState3, 1),
      labelUniqueId = _useState4[0];

  var _useState5 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('rangeslider')),
      _useState6 = _slicedToArray(_useState5, 1),
      inputUniqueId = _useState6[0];

  var _useState7 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState8 = _slicedToArray(_useState7, 1),
      descriptionUniqueId = _useState8[0];

  var getBackgroundSize = function getBackgroundSize() {
    var rangeHigh = maxValue - minValue;
    var currentValue = value - minValue;

    if (isDisabled) {
      return {
        backgroundSize: "cover, 100%"
      };
    }

    if (value === '') {
      return {
        backgroundSize: "cover,  0%"
      };
    }

    return {
      backgroundSize: "cover, ".concat(currentValue / rangeHigh * 100, "% 100%")
    };
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("range-slider", classes),
    id: formControlId,
    ref: ref
  }, additionalProps), /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    isOptional: isOptional,
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId,
    type: "text"
  }), /*#__PURE__*/_react.default.createElement("input", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    "aria-describedby": (description || errorMessages && !isValid) && (descriptionId || descriptionUniqueId) || null,
    "aria-disabled": isDisabled ? true : null,
    "aria-valuenow": value,
    "aria-valuetext": "".concat(value).concat(ariaValueTextLabel),
    "data-testid": dataTestId,
    disabled: isDisabled || null,
    id: inputId || inputUniqueId,
    max: maxValue,
    min: minValue,
    onInput: function onInput(event) {
      handleSetValue(event);

      if (handleOnInput) {
        handleOnInput(event);
      }
    },
    step: stepBy,
    style: getBackgroundSize(),
    type: "range",
    value: value
  }), (description || errorMessages.length > 0 && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid
  }));
});
RangeSlider.displayName = 'RangeSlider';
RangeSlider.propTypes = {
  /**
   Optional. String passed to range slider element's aria-label attribute. Announces range slider context to screen-reader users. eg: 'Loan amount range slider'. If there is no visual label, an `ariaLabel` or `ariaLabelledBy` prop must be passed instead to identify each thumb to screen readers.
    Defaults to `null`.
   */
  ariaLabel: _propTypes.default.string,

  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. Label that is appended after value to announce in screen readers. Defaults to `null`.
   */
  ariaValueTextLabel: _propTypes.default.string,

  /**
   Optional. String to add custom class(es) to the button.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description that appears below the checkbox. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. A unique identifier passed to the description's `id` attribute. Defaults to `null`.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings displayed when `isValid` is `false`.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. A unique identifier passed to the component wrapper's `id` attribute. Defaults to `null`.
   */
  formControlId: _propTypes.default.string,

  /**
   Optional. The function passed to the input's `onInput` method.
   */
  handleOnInput: _propTypes.default.func,

  /**
   Optional. Used to pass HTML to the `description` prop. Defaults to `false`.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Initial value of the range slider.
   */
  initialValue: _propTypes.default.string.isRequired,

  /**
   Optional. A unique identifier passed to the input's `id` attribute. Defaults to `null`.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. Adds the `disabled` attribute to the button. Defaults to `false`.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Adds "Optional" text to the right of the legend. Defaults to `false`.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Sets the error state for the component and it's checkboxes when set to `false`. Defaults to `true`.
   */
  isValid: _propTypes.default.bool,

  /**
   Optional. The label that appears above the range slider input. If there is no visual label, an `ariaLabel` or `ariaLabelledBy` prop must be passed instead to identify each thumb to screen readers.
    Defaults to `null`.
   */
  label: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the input label's `id` attribute. Defaults to `null`.
   */
  labelId: _propTypes.default.string,

  /**
   Required. Minimum range value allowed. Defaults to `null`.
   */
  minValue: _propTypes.default.string.isRequired,

  /**
   Required. Maximum range value allowed. Defaults to `null`.
   */
  maxValue: _propTypes.default.string.isRequired,

  /**
   Required. Step by  value for range slider to increment by.
   */
  stepBy: _propTypes.default.string.isRequired
};
RangeSlider.defaultProps = {
  ariaLabel: null,
  ariaLabelledBy: null,
  ariaValueTextLabel: '',
  classes: '',
  description: '',
  descriptionId: '',
  dataTestId: null,
  errorMessages: [],
  // TODO, this is the probelm...
  formControlId: null,
  handleOnInput: null,
  isDescriptionHtml: false,
  isDisabled: false,
  isOptional: false,
  isValid: true,
  inputId: '',
  label: '',
  labelId: ''
};
var _default = RangeSlider;
exports.default = _default;